import { c as _c } from "react/compiler-runtime";
import { Box, CircularProgress } from "@mui/material";
export const StepLoader = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100svh"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box sx={t0}><CircularProgress sx={{
        color: "text.secondary"
      }} /></Box>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};